import logo from './logo.svg';
import './App.css';
import MonerisIframe from './components/MonerisIframe';
 
function App() {
  return (
    <div className="App">
      <MonerisIframe />
    </div>
  );
}
 
export default App;